import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../utils/api";
import ScrollToTop from "../../Component/ScrollToTop";

const Profile = () => {
  const navigate = useNavigate();

  /* ================= STATES ================= */
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [role, setRole] = useState("");
  const [loading, setLoading] = useState(false);

  /* ================= AUTH CHECK ================= */
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/MyAccountSignIn");
    }
  }, [navigate]);

  /* ================= FETCH PROFILE ================= */
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await api.get("/api/auth/me");

        if (res.data?.success) {
          const user = res.data.user;
          setName(user.name || "");
          setEmail(user.email || "");
          setPhone(user.phone || "");
          setRole(user.role || "");
        }
      } catch (error) {
        console.error("PROFILE FETCH ERROR:", error);
        alert("Session expired. Please login again.");
        localStorage.clear();
        navigate("/MyAccountSignIn");
      }
    };

    fetchProfile();
  }, [navigate]);

  /* ================= UPDATE PROFILE ================= */
  const handleUpdateProfile = async (e) => {
    e.preventDefault();

    if (!/^[0-9]{10}$/.test(phone)) {
      alert("Enter a valid 10-digit phone number");
      return;
    }

    try {
      setLoading(true);

      const res = await api.put("/api/auth/update", {
        name,
        email,
        phone,
      });

      if (res.data?.success) {
        alert("✅ Profile updated successfully");
        localStorage.setItem("user", JSON.stringify(res.data.user));
      }
    } catch (error) {
      console.error("PROFILE UPDATE ERROR:", error);
      alert(error.response?.data?.message || "Profile update failed");
    } finally {
      setLoading(false);
    }
  };

  /* ================= LOGOUT ================= */
  const handleLogout = () => {
    localStorage.clear();
    navigate("/MyAccountSignIn");
  };

  return (
    <div>
      <ScrollToTop />

      <section className="my-lg-14 my-8">
        <div className="container">
          <div className="row justify-content-center">

            <div className="col-lg-6 col-md-8">
              <div className="card shadow-sm">
                <div className="card-body">

                  <h2 className="mb-4 fw-bold text-center">
                    My Profile
                  </h2>

                  <form onSubmit={handleUpdateProfile}>

                    {/* NAME */}
                    <div className="mb-3">
                      <label className="form-label">Full Name</label>
                      <input
                        type="text"
                        className="form-control"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                      />
                    </div>

                    {/* EMAIL */}
                    <div className="mb-3">
                      <label className="form-label">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                      />
                    </div>

                    {/* PHONE */}
                    <div className="mb-3">
                      <label className="form-label">Phone</label>
                      <input
                        type="tel"
                        className="form-control"
                        value={phone}
                        maxLength={10}
                        onChange={(e) =>
                          setPhone(e.target.value.replace(/\D/g, ""))
                        }
                        required
                      />
                    </div>

                    {/* ROLE */}
                    <div className="mb-3">
                      <label className="form-label">Role</label>
                      <input
                        type="text"
                        className="form-control"
                        value={role}
                        disabled
                      />
                    </div>

                    {/* ACTIONS */}
                    <div className="d-grid gap-2">
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loading}
                      >
                        {loading ? "Updating..." : "Update Profile"}
                      </button>

                      <button
                        type="button"
                        className="btn btn-outline-danger"
                        onClick={handleLogout}
                      >
                        Logout
                      </button>
                    </div>

                  </form>

                </div>
              </div>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default Profile;